import React, { useState } from 'react'
import { Radio } from 'antd';

interface RadioGroupProps {
  items: Array<{
    name: string;
    value: string;
  }>;
  onChange: (select: string) => void
}

function RadioGroup({items, onChange}: RadioGroupProps) {
  const [active, setActive] = useState(items[0]?.value);
  return (
    <>
    <Radio.Group value={active} onChange={(e) => {
      setActive(e.target.value);
      onChange(e.target.value)
    }}>
      {items.map((item) => (<Radio.Button key={item.value} value={item.value}>{item.name}</Radio.Button>))}
    </Radio.Group>
    </>
  )
}

export default RadioGroup;